import React from "react";

export default function ProphetMuhammadFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-prop41{fill:#c3821a}.cls-prop42{fill:#25215c}"}</style>
        </defs>
        <path
          d="M1493.02 857.05a615.18 615.18 0 0 0-20.44-8.2c-8.01-3.07-17.19-6.39-27.32-9.73-42.97-14.22-81.5-21.89-118.95-25.8-3.94-.41-7.86-.78-11.77-1.11-2.22-.19-4.44-.36-6.65-.53-5.93-.43-11.84-.79-17.76-1.07-48.21-2.28-96.43.28-152.04 1.6l-1.33.03c-1.43.04-2.87.07-4.31.1-4.24.09-8.73.18-13.45.27-57.76 1.05-149.33 1.52-236.93 1.45-6.38 0-12.73 0-19.05-.02-57.81-.1-112.65-.44-153.37-1.01-6.19-.09-12.05-.18-17.55-.28-6.71-.12-12.87-.25-18.42-.38-2.08-.05-4.08-.11-5.99-.16-4.75-.13-12.33-.36-22.07 0-17.66.66-42.42 3.29-70.28 12.03-.03 0-.06 0-.08.03-30.57 9.59-53.71 23.07-68.29 32.78C521.58 597 739.54 390.94 999.99 390.94S1478.41 597 1493.02 857.05Z"
          className="cls-prop42"
        />
        <path
          d="M1354.96 1949.62H645.04c-58.38 0-113.27-22.74-154.55-64.02-41.28-41.28-64.02-96.17-64.02-154.55v-709.92c0-58.38 22.73-113.27 64.02-154.55 41.28-41.28 96.17-64.02 154.55-64.02h709.92c58.38 0 113.27 22.73 154.55 64.02 41.28 41.28 64.02 96.17 64.02 154.55v709.92c0 58.38-22.73 113.27-64.02 154.55-41.28 41.28-96.17 64.02-154.55 64.02ZM645.04 825.56c-107.84 0-195.58 87.74-195.58 195.58v709.92c0 107.84 87.74 195.58 195.58 195.58h709.92c107.84 0 195.58-87.74 195.58-195.58v-709.92c0-107.84-87.74-195.58-195.58-195.58H645.04Z"
          className="cls-prop42"
        />
        <rect
          width={273.28}
          height={142.27}
          x={863.36}
          y={319.8}
          className="cls-prop42"
          rx={49.3}
          ry={49.3}
        />
        <rect
          width={147.33}
          height={90.26}
          x={926.34}
          y={264.85}
          className="cls-prop42"
          rx={28.83}
          ry={28.83}
        />
        <path
          d="M1012.9 319.1c-9.19.23-18.38.45-27.57.68 2.84-47.89 5.68-95.78 8.53-143.67h12.3l6.75 142.98Z"
          className="cls-prop42"
        />
        <path
          d="M1081.58 140.17c-5.77 39.64-39.9 70.08-81.14 70.08-45.29 0-82.01-36.72-82.01-82.01 0-36.28 23.57-67.06 56.23-77.86-13.29 12.77-21.57 30.72-21.57 50.62 0 38.78 31.44 70.21 70.21 70.21 24.27 0 45.67-12.31 58.28-31.04Z"
          className="cls-prop42"
        />
        <path
          d="M1018.85 578.73c-1.26 8.65-8.71 15.29-17.7 15.29-9.88 0-17.89-8.01-17.89-17.89 0-7.92 5.14-14.63 12.27-16.99-2.9 2.79-4.71 6.7-4.71 11.05 0 8.46 6.86 15.32 15.32 15.32 5.3 0 9.96-2.69 12.72-6.77ZM1119.01 759.02v53.59c-57.76 1.05-149.33 1.52-236.93 1.45v-55.73c0-28.87 19.51-54.89 49.41-65.79 9.99-3.64 20.51-8.77 30.76-16 10.54-7.44 18.56-15.51 24.6-23.02.24-.29.48-.59.71-.9a116.736 116.736 0 0 0 7.24-10.26c.04-.06.07-.12.11-.17 1.19-1.75 3.2-2.62 5.22-2.62s4.19.95 5.35 2.84c.09.14.17.28.27.43 1.46 2.37 3.16 4.92 5.12 7.57.22.3.44.61.68.91 6.54 8.73 15.84 18.53 28.83 27.28 9.76 6.57 19.7 11.26 29.15 14.6 30.04 10.65 49.48 36.93 49.48 65.82Z"
          className="cls-prop41"
        />
        <path
          d="M1014.2 654.77c-9.54.09-19.07.18-28.61.28 3.27-3.82 7.91-10.26 10.48-19.12a47.332 47.332 0 0 0 1.79-15.89h5.36c-.47 3.87-.63 9.44 1.02 15.89 2.27 8.88 6.89 15.26 9.96 18.85Z"
          className="cls-prop41"
        />
        <rect
          width={46.34}
          height={11.74}
          x={977.37}
          y={639.57}
          className="cls-prop41"
          rx={5.87}
          ry={5.87}
        />
        <rect
          width={23.68}
          height={11.74}
          x={988.7}
          y={620.02}
          className="cls-prop41"
          rx={5.7}
          ry={5.7}
        />
        <path
          d="M1012.93 643.26c-7.91-.47-15.83-.94-23.74-1.42.16-.09 3.78-2.07 4.27-6.8.39-3.78-1.51-6.44-1.8-6.83 2.69-13.66 5.37-27.33 8.06-40.99h1.79c2.69 13.63 5.39 27.26 8.08 40.88-.31.4-2.55 3.31-2.15 7.45.34 3.57 2.51 6.62 5.49 7.71ZM1290.14 788.16v24.04H1138.1l-1.33.03V787.7c0-18.68 12.63-35.52 31.98-42.58 6.47-2.36 13.28-5.68 19.91-10.36 7.09-5 12.42-10.45 16.38-15.47.04-.05.07-.08.09-.12.2-.25.39-.49.56-.73 1.57-2.04 2.9-3.99 4.04-5.8.02-.04.05-.07.08-.11 1.56-2.31 5.37-2.25 6.84.14.06.09.11.19.18.28.95 1.54 2.05 3.2 3.33 4.93l.06.09c.12.15.23.31.36.47 4.23 5.65 10.25 11.99 18.66 17.65 6.31 4.26 12.75 7.29 18.86 9.46 19.45 6.89 32.04 23.9 32.04 42.61Z"
          className="cls-prop41"
        />
        <path
          d="m1222.29 720.68-18.52.18c2.12-2.47 5.12-6.64 6.78-12.38 1.19-4.09 1.31-7.68 1.16-10.29h3.47a27.7 27.7 0 0 0 .66 10.29c1.47 5.75 4.46 9.88 6.45 12.2Z"
          className="cls-prop41"
        />
        <rect
          width={29.99}
          height={7.6}
          x={1198.45}
          y={710.84}
          className="cls-prop41"
          rx={3.8}
          ry={3.8}
        />
        <rect
          width={15.33}
          height={7.6}
          x={1205.79}
          y={698.19}
          className="cls-prop41"
          rx={3.69}
          ry={3.69}
        />
        <path
          d="M1221.47 713.23c-5.12-.31-10.25-.61-15.37-.92.11-.06 2.45-1.34 2.76-4.4.25-2.45-.98-4.17-1.16-4.42 1.74-8.85 3.48-17.69 5.22-26.53h1.16c1.74 8.82 3.49 17.64 5.23 26.46-.2.26-1.65 2.14-1.39 4.82.22 2.31 1.62 4.28 3.55 4.99ZM863.03 788.16v25.87c-57.81-.1-112.65-.44-153.37-1.01V787.7c0-18.68 12.63-35.52 31.99-42.58 6.46-2.36 13.27-5.68 19.91-10.36 6.36-4.48 11.3-9.33 15.11-13.91.08-.1.17-.19.25-.3.35-.42.69-.84 1.02-1.26.03-.05.06-.08.09-.12.2-.25.39-.49.56-.73 1.57-2.04 2.9-3.99 4.04-5.8.02-.04.05-.07.08-.11 1.56-2.31 5.36-2.25 6.83.14.06.09.11.19.18.28.95 1.54 2.06 3.2 3.33 4.93l.06.09c.12.15.24.31.36.47 4.24 5.65 10.26 11.99 18.66 17.65 6.32 4.26 12.75 7.29 18.87 9.46 19.45 6.89 32.03 23.9 32.03 42.61Z"
          className="cls-prop41"
        />
        <path
          d="m795.19 720.68-18.52.18c2.12-2.47 5.12-6.64 6.78-12.38 1.19-4.09 1.31-7.68 1.16-10.29h3.47a27.7 27.7 0 0 0 .66 10.29c1.47 5.75 4.46 9.88 6.45 12.2Z"
          className="cls-prop41"
        />
        <rect
          width={29.99}
          height={7.6}
          x={771.35}
          y={710.84}
          className="cls-prop41"
          rx={3.8}
          ry={3.8}
        />
        <rect
          width={15.33}
          height={7.6}
          x={778.68}
          y={698.19}
          className="cls-prop41"
          rx={3.69}
          ry={3.69}
        />
        <path
          d="M794.36 713.23c-5.12-.31-10.25-.61-15.37-.92.11-.06 2.45-1.34 2.76-4.4.25-2.45-.98-4.17-1.16-4.42 1.74-8.85 3.48-17.69 5.22-26.53h1.16c1.74 8.82 3.49 17.64 5.23 26.46-.2.26-1.65 2.14-1.39 4.82.22 2.31 1.62 4.28 3.55 4.99ZM692.11 645.43v167.32c-6.71-.12-12.87-.25-18.42-.38V645.43c.03-.29.07-.57.1-.86 3.17-26.93 6.34-53.86 9.52-80.79 2.9 26.93 5.8 53.86 8.71 80.79l.09.86Z"
          className="cls-prop41"
        />
        <path
          d="M692.1 659.72h-18.42c-1.01-3.89-2.03-7.77-3.04-11.66-.44-1.68.39-3.49 1.61-3.49h21.3c1.21 0 2.04 1.81 1.61 3.49-1.01 3.89-2.03 7.77-3.04 11.66ZM692.1 757.97h-18.42c-1.29-3.89-5.12-8.18-6.41-12.07-.56-1.68.5-3.49 2.05-3.49h27.14c1.54 0 2.61 1.81 2.05 3.49-1.29 3.89-5.12 8.19-6.41 12.07ZM1326.32 645.43v167.89c-3.94-.41-7.86-.78-11.77-1.11h-6.65V645.43c.03-.29.07-.57.1-.86 3.18-26.93 6.35-53.86 9.52-80.79 2.91 26.93 5.81 53.86 8.71 80.79l.09.86Z"
          className="cls-prop41"
        />
        <path
          d="M1326.32 659.72h-18.42c-1.01-3.89-2.03-7.77-3.04-11.66-.44-1.68.39-3.49 1.61-3.49h21.3c1.21 0 2.04 1.81 1.61 3.49-1.01 3.89-2.03 7.77-3.04 11.66ZM1326.32 757.97h-18.42c-1.29-3.89-5.12-8.18-6.41-12.07-.56-1.68.5-3.49 2.05-3.49h27.14c1.54 0 2.61 1.81 2.05 3.49-1.29 3.89-5.12 8.19-6.41 12.07Z"
          className="cls-prop41"
        />
        {children}
      </g>
    </svg>
  );
}
